import { render } from "./PromoCouponCard.vue?vue&type=template&id=6f7aadd4&scoped=true"
import script from "./PromoCouponCard.vue?vue&type=script&lang=js"
export * from "./PromoCouponCard.vue?vue&type=script&lang=js"

import "./PromoCouponCard.vue?vue&type=style&index=0&id=6f7aadd4&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6f7aadd4"]])

export default __exports__